export default __webpack_public_path__ + "static/media/reachship_logo_transparent_dark.958beaf7.svg";